export enum Events {
    INIT = 'init',
    COMPONENT_DID_MOUNT = 'ComponentDidMount',
    COMPONENT_RENDER = 'ComponentRender',
    COMPONENT_DID_UNMOUNT = 'ComponentDidUnmount',
    COMPONENT_DID_UPDATE = 'ComponentDidUpdate'
}
